import { Directive, Input, HostBinding, HostListener, OnInit, OnDestroy } from '@angular/core';
import { KeyboardService } from '../keyboard.service';


@Directive({
  selector: '[appTeclas]'
})
export class TeclasDirective implements OnInit, OnDestroy {
  private _values: string[];

  @Input('appTeclas') values: string;

  @HostBinding('innerText') currentValue: string;

  constructor(private keyboard: KeyboardService) { }

  ngOnInit() {
    this._values = this.values.split(' ');
  //  this.currentValue = this._values[0];
    this.currentValue = this.values;
  }

  ngOnDestroy() {
    this.keyboard.shiftChanged.unsubscribe();
    this.keyboard.altChanged.unsubscribe();
  }



  @HostListener('click')
  onClick() {
    this.keyboard.fireKeyPressed(this.currentValue);
  }
}
